import React, { Component } from 'react'
import { Link } from 'react-router'
import { ListGroup } from 'react-bootstrap'

export default class ForumList extends Component {

  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className='container-fluid'>
        <div className='panel'>
          <header className='panel-heading'>Forums</header>
          <div className='panel-body'>
            <ListGroup>
              { this.props.forums.map(forum => {
                return (
                  <Link key={forum._id} to={`/forum/${encodeURIComponent(forum.title.split(' ').join(''))}`} className='list-group-item forum'>
                    <h4 className='list-group-item-heading'>{ forum.title }</h4>
                    <p className='list-group-item-text'>{ forum.description }</p>
                  </Link>
                )
              })}
            </ListGroup>
          </div>
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/forum/ForumList.js
 **/